export default {
  namespaced: true,
  state: {
    tradeModal: {
      show: false,
      id: null,
      type: "",
      groupId: null,
      copyTradeDetail: {},
      filter_by: "",
      security: null,
      trade_type: "",
      isNifty50: false,
      isBuySellButton: false,
      isTrading: false,
    },
  },
  getters: {
    getShow: (state) => state.tradeModal.show,
    getTradeType: (state) => state.tradeModal.trade_type,
    getNifty50: (state) => state.tradeModal.isNifty50,
    isBuySellButton: (state) => state.tradeModal.isBuySellButton,
    getIsTrading: (state) => state.tradeModal.isTrading,
  },
  mutations: {
    TOGGLE_TRADE_MODAL(state, obj) {
      if (obj.show) {
        state.tradeModal.id = obj.id ? obj.id : null;
        state.tradeModal.type = obj.type ? obj.type : "";
        state.tradeModal.groupId = obj.groupId ? obj.groupId : null;
        state.tradeModal.copyTradeDetail = obj.copyDetail ? obj.copyDetail : {};
        state.tradeModal.filter_by = obj.filter_by ? obj.filter_by : "";
        state.tradeModal.security = obj.security ? obj.security : null;
        state.tradeModal.trade_type = obj.trade_type ? obj.trade_type : "";
        state.tradeModal.isNifty50 = obj.isNifty50 ? obj.isNifty50 : false;
        state.tradeModal.isNifty50 = obj.isNifty50 ? obj.isNifty50 : false;
        state.tradeModal.isTrading = obj.isTrading ? obj.isTrading : false;
      }
      state.tradeModal.show = obj.show;
    },
  },
  actions: {
    toggleTradeModal({ commit }, obj) {
      commit("TOGGLE_TRADE_MODAL", obj);
    },
  },
};
